import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useGame } from "../context/GameContext";
import { Coins, Star, Gem, Flame, Home } from "lucide-react";

const Stat = ({ icon: Icon, value, color, testid }) => (
  <motion.div
    data-testid={testid}
    whileHover={{ scale: 1.05 }}
    className="flex items-center gap-1.5 rounded-full bg-white/90 px-3 py-1.5 shadow-md font-display font-bold text-slate-700"
  >
    <Icon className="h-5 w-5" style={{ color }} />
    <span className="tabular-nums">{value}</span>
  </motion.div>
);

export const TopBar = ({ showHome = true, title = null }) => {
  const { profile } = useGame();
  const navigate = useNavigate();
  if (!profile) return null;
  return (
    <div className="sticky top-0 z-40 flex items-center justify-between gap-2 px-4 py-3 backdrop-blur-md bg-white/40">
      <div className="flex items-center gap-2">
        {showHome && (
          <motion.button
            data-testid="topbar-home-btn"
            whileTap={{ scale: 0.9 }}
            onClick={() => navigate("/spelen")}
            className="rounded-full bg-white p-2.5 shadow-md text-sky-500"
            aria-label="Home"
          >
            <Home className="h-5 w-5" />
          </motion.button>
        )}
        {title && <span className="font-display text-lg font-bold text-slate-700">{title}</span>}
      </div>
      <div className="flex items-center gap-2">
        <Stat testid="stat-coins" icon={Coins} value={profile.coins} color="#EAB308" />
        <Stat testid="stat-stars" icon={Star} value={profile.stars} color="#FB923C" />
        <Stat testid="stat-diamonds" icon={Gem} value={profile.diamonds} color="#38BDF8" />
        <Stat testid="stat-streak" icon={Flame} value={profile.streak_count} color="#EF4444" />
      </div>
    </div>
  );
};

export default TopBar;
